module.exports = __webpack_public_path__ + "img/imagen1.cd6c7024.png";